import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AccountComponent } from './account/account.component';
import { InvoiceComponent } from './invoice/invoice.component';
import { InvoiceDetailsComponent } from './invoice/invoice-details/invoice-details.component'; // Assuming DialogComponent is a routed component, not a modal dialog service.
import { AccountingComponent } from './accounting.component';
import { AccountDetailsComponent } from './account/account-details/account-details.component';
import { StripeComponent } from './stripe/stripe.component';
import { StripeLogsComponent } from './stripe-logs/stripe-logs.component';
import { SearchGridComponent } from '../../common/search-grid/search-grid.component';

const routes: Routes = [
  {
    path: '',
    component: AccountingComponent,
    children: [
      { path: 'account', component: AccountComponent },
      {
        path: 'account/account-details/:id',
        component: AccountDetailsComponent,
      }, // For direct access without ID
      { path: 'invoice', component: InvoiceComponent },
      {
        path: 'invoice/invoice-details/:id',
        component: InvoiceDetailsComponent,
      },
      {
        path: 'payments',
        component: StripeComponent,
        //   children: [
        //   { path: ':id', component: LogsComponent },
        // ]
      },
      { path: 'payments/stripe/:id', component: StripeLogsComponent },
      { path: 'payments/searchresults', component: SearchGridComponent },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AccountingRoutingModule {}
